// src/components/ProductPrice/ProductPrice.js
import React from "react";
import { useSelector } from "react-redux";

const SYMBOLS = { PLN: "zł", EUR: "€", USD: "$" };

const ProductPrice = ({ basePrice }) => {
    const currency = useSelector((state) => state.currency.selectedCurrency);
    const rates = useSelector((state) => state.currency.rates);

    const convert = price =>
        rates && rates[currency] ? (price * rates[currency]).toFixed(2) : price;

    if (basePrice === undefined || basePrice === null) return null;

    return (
        <>
            {convert(basePrice)} {SYMBOLS[currency] || currency}
        </>
    );
};

export default ProductPrice;
